import React from 'react'
import Flickity from 'react-flickity-component'
import HeroSlide from './HeroSlide'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons'
import jump from 'jump.js'
import { withNullErrorBoundary } from '../../utils/withNullErrorBoundary'
import {
  HeroWrapper,
  ScrollDownLinkWrapper,
  ScrollDownLink,
  CarouselIndexWrapper,
  CarouselIndexMarker,
} from './HeroBanner'

class HeroBannerWrapper extends React.Component {
  constructor(props) {
    super(props)
    this.scrollRef = React.createRef()
    this.state = {
      showingStatic: true,
      currentSlide: 0,
    }
  }

  updateScrollDown = () => {
    const windowScrollTop = window.pageYOffset
    // const scrollDownTop = this.scrollRef.current.getBoundingClientRect().top

    if (windowScrollTop > 100) {
      this.scrollRef.current && this.scrollRef.current.classList.add('hidden')
    } else {
      this.scrollRef.current &&
        this.scrollRef.current.classList.remove('hidden')
    }
  }

  onScrollEvent = () => {
    window.requestAnimationFrame(this.updateScrollDown)
  }

  componentDidMount() {
    this.flkty.on('change', (index) => {
      this.setState({
        currentSlide: index,
      })
    })

    this.flkty.on('ready', () => {
      console.log('flickity ready')
      this.setState({
        showingStatic: false,
      })
    })

    if (window) {
      window.addEventListener('scroll', this.onScrollEvent)
      window.addEventListener('resize', this.onScrollEvent)
      setTimeout(() => {
        this.onScrollEvent()
      }, 1000)
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('scroll', this.onScrollEvent)
      window.removeEventListener('resize', this.onScrollEvent)
    }
  }

  ScrollBottom() {
    jump('.services', {
      duration: 1000,
      offset: -1 * document.getElementById('main-header').offsetHeight,
      a11y: false,
    })
  }

  render() {
    const firstTab = this?.props?.tabs?.length ? this.props.tabs[0] : null
    const { showingStatic } = this.state

    const flickityOptions = {
      freeScroll: false,
      cellSelector: '.slide',
      contain: false,
      initialIndex: 0,
      accessibility: false,
      pageDots: false,
      wrapAround: false,
      prevNextButtons: false,
      fade: true,
      autoPlay: 6000,
      resize: true,
    }

    return (
      <>
        <HeroWrapper
          style={{
            display: showingStatic ? 'block' : 'none',
          }}
        >
          {firstTab && (
            <HeroSlide
              key={firstTab?.tabIndexText}
              index={0}
              topContent={firstTab?.aboveTitleText}
              bottomContent={firstTab?.belowTitleText}
              imgSrc={firstTab?.tabImage?.localFile?.childImageSharp?.fluid}
              title={firstTab?.titleText}
              button={
                firstTab.buttonLink && firstTab.buttonText
                  ? {
                      text: firstTab.buttonText,
                      url: firstTab.buttonLink?.uri,
                    }
                  : null
              }
            />
          )}
          {/* //Navigation */}
          <CarouselIndexWrapper>
            {this?.props?.tabs?.map((props, index) => (
              <CarouselIndexMarker
                key={props?.tabIndexText}
                className={
                  this.state.currentSlide === index ? 'is-selected' : ''
                }
              >
                {props?.tabIndexText}
              </CarouselIndexMarker>
            ))}
          </CarouselIndexWrapper>
          <ScrollDownLinkWrapper>
            <ScrollDownLink
              ref={this.scrollRef}
              href="#scrolldown"
              onClick={() => this.ScrollBottom()}
            >
              Scroll down
              <span>
                <FontAwesomeIcon icon={faAngleDown} />
              </span>
            </ScrollDownLink>
          </ScrollDownLinkWrapper>
        </HeroWrapper>
        <HeroWrapper
          style={{
            display: !showingStatic ? 'block' : 'none',
          }}
        >
          <Flickity
            options={flickityOptions}
            flickityRef={(ref) => (this.flkty = ref)}
            disableImagesLoaded={true}
          >
            {this?.props?.tabs?.map((props, i) => (
              <HeroSlide
                key={props?.tabIndexText}
                index={i}
                topContent={props?.aboveTitleText}
                bottomContent={props?.belowTitleText}
                imgSrc={props?.tabImage?.localFile?.childImageSharp?.fluid}
                title={props?.titleText}
                button={
                  props.buttonLink && props.buttonText
                    ? {
                        text: props.buttonText,
                        url: props.isButtonLinkExternal
                          ? props.buttonLinkExternal
                          : props.buttonLink?.uri,
                        tab: props.isButtonLinkExternal ? '_blank' : '_self',
                      }
                    : null
                }
              />
            ))}
          </Flickity>
          {/* //Navigation */}
          <CarouselIndexWrapper>
            {this?.props?.tabs?.map((props, index) => (
              <CarouselIndexMarker
                key={props?.tabIndexText}
                className={
                  this.state.currentSlide === index ? 'is-selected' : ''
                }
                onClick={() => {
                  this.flkty.select(index, true)
                }}
              >
                {props?.tabIndexText}
              </CarouselIndexMarker>
            ))}
          </CarouselIndexWrapper>
          <ScrollDownLinkWrapper>
            <ScrollDownLink
              ref={this.scrollRef}
              href="#scrolldown"
              onClick={() => this.ScrollBottom()}
            >
              Scroll down
              <span>
                <FontAwesomeIcon icon={faAngleDown} />
              </span>
            </ScrollDownLink>
          </ScrollDownLinkWrapper>
        </HeroWrapper>
      </>
    )
  }
}

export default withNullErrorBoundary(HeroBannerWrapper)
